import { Button, MessageBox, MessageBoxType, Toast } from '@ui5/webcomponents-react';
import { createPortal } from 'react-dom';
import { useEffect } from 'react';

export type ResultUserMessage = {
  isSuccess: boolean;
  message: string;
};

interface UserMessageProps {
  isVisible: boolean;
  resultMessage: ResultUserMessage;
  onResetUserMessage: () => void;
  toastDuration?: number;
}

export const UserMessage: React.FC<UserMessageProps> = (props) => {
  const { isVisible, resultMessage, onResetUserMessage, toastDuration } = props;
  const TOAST_DURATION = toastDuration ?? 4000;

  const onClose = () => {
    onResetUserMessage();
  };

  const isToShowErrorMessage = () => {
    return isVisible && !resultMessage.isSuccess;
  };

  const isToShowSuccessMessage = () => {
    return isVisible && resultMessage.isSuccess;
  };

  // Workaround to fire onClose method due Toast component doesn't have an event to do it
  useEffect(() => {
    if (resultMessage.isSuccess) {
      setTimeout(() => onClose(), TOAST_DURATION);
    }
  }, [resultMessage.isSuccess]);

  return (
    <>
      {isToShowErrorMessage() &&
        createPortal(
          <MessageBox
            open={isVisible}
            type={MessageBoxType.Error}
            onClose={onClose}
            actions={[
              <Button key="confirm-ok" id="confirm-ok" onClick={onClose}>
                Ok
              </Button>
            ]}
            data-testid="error-messagebox"
          >
            {resultMessage.message}
          </MessageBox>,
          document.body
        )}
      <Toast
        data-testid="assign-query-toast"
        open={isToShowSuccessMessage()}
        duration={TOAST_DURATION}
        onClose={onClose}
      >
        {resultMessage.message}
      </Toast>
    </>
  );
};
